export default [
  {
    geoJSON: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.69718777028439, 40.0903753241515]
      },
      properties: {
        video: 'Vuelo Corto',
        videoTime: 133937024.00000001,
        videoPosition: {
          x: 370.75,
          y: 137,
          width: 549,
          height: 309
        },
        template: {
          _id: 'Basica',
          name: 'Basica',
          icon: 'apple-alt',
          tags: [
            {
              id: 'prueba',
              text: 'prueba'
            },
            {
              id: 'texto',
              text: 'texto'
            }
          ],
          elements: [
            {
              row: 1,
              column: 1,
              order: 1,
              elementKey: 'prueba select',
              elementType: 'select',
              labelName: 'Categoría',
              optionList: [
                'Urbano',
                'Paso elevado',
                'Tendido eléctrico',
                'Ferrocarril',
                'Cruce camino',
                'Torre eléctrica',
                'Poste'
              ],
              value: 'Cruce camino'
            },
            {
              row: 2,
              column: 1,
              order: 1,
              elementKey: 'prueba texto',
              elementType: 'input',
              labelName: 'Nombre',
              dataType: 'text',
              value: 'Cruce de camino'
            }
          ]
        }
      }
    },
    origin: 'manual'
  },
  {
    geoJSON: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.69979933982652, 40.0800444943349]
      },
      properties: {
        video: 'Vuelo Corto',
        videoTime: 209294104,
        videoPosition: {
          x: 280.75,
          y: 175,
          width: 549,
          height: 309
        },
        template: {
          _id: 'Basica',
          name: 'Basica',
          icon: 'apple-alt',
          tags: [
            {
              id: 'prueba',
              text: 'prueba'
            },
            {
              id: 'texto',
              text: 'texto'
            }
          ],
          elements: [
            {
              row: 1,
              column: 1,
              order: 1,
              elementKey: 'prueba select',
              elementType: 'select',
              labelName: 'Categoría',
              optionList: [
                'Urbano',
                'Paso elevado',
                'Tendido eléctrico',
                'Ferrocarril',
                'Cruce camino',
                'Torre eléctrica',
                'Poste'
              ],
              value: 'Urbano'
            },
            {
              row: 2,
              column: 1,
              order: 1,
              elementKey: 'prueba texto',
              elementType: 'input',
              labelName: 'Nombre',
              dataType: 'text',
              value: 'Caseta cultivo'
            }
          ]
        }
      }
    },
    origin: 'manual'
  },
  {
    geoJSON: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.70610077224431, 40.089233169314]
      },
      properties: {
        video: 'Vuelo Corto',
        videoTime: 285130710,
        videoPosition: {
          x: 179.75,
          y: 97,
          width: 549,
          height: 309
        },
        template: {
          _id: 'Basica',
          name: 'Basica',
          icon: 'apple-alt',
          tags: [
            {
              id: 'prueba',
              text: 'prueba'
            },
            {
              id: 'texto',
              text: 'texto'
            }
          ],
          elements: [
            {
              row: 1,
              column: 1,
              order: 1,
              elementKey: 'prueba select',
              elementType: 'select',
              labelName: 'Categoría',
              optionList: [
                'Urbano',
                'Paso elevado',
                'Tendido eléctrico',
                'Ferrocarril',
                'Cruce camino',
                'Torre eléctrica',
                'Poste'
              ],
              value: 'Torre eléctrica'
            },
            {
              row: 2,
              column: 1,
              order: 1,
              elementKey: 'prueba texto',
              elementType: 'input',
              labelName: 'Nombre',
              dataType: 'text',
              value: 'Torre de alta tensión'
            }
          ]
        }
      }
    },
    origin: 'manual'
  },
  {
    geoJSON: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.697691158686, 40.0915394738035]
      },
      properties: {
        video: 'Vuelo Corto',
        videoTime: 401841808,
        videoPosition: {
          x: 250.75,
          y: 130,
          width: 549,
          height: 309
        },
        template: {
          _id: 'Basica',
          name: 'Basica',
          icon: 'apple-alt',
          tags: [
            {
              id: 'prueba',
              text: 'prueba'
            },
            {
              id: 'texto',
              text: 'texto'
            }
          ],
          elements: [
            {
              row: 1,
              column: 1,
              order: 1,
              elementKey: 'prueba select',
              elementType: 'select',
              labelName: 'Categoría',
              optionList: [
                'Urbano',
                'Paso elevado',
                'Tendido eléctrico',
                'Ferrocarril',
                'Cruce camino',
                'Torre eléctrica',
                'Poste'
              ],
              value: 'Urbano'
            },
            {
              row: 2,
              column: 1,
              order: 1,
              elementKey: 'prueba texto',
              elementType: 'input',
              labelName: 'Nombre',
              dataType: 'text',
              value: 'Cultivo no registrado'
            }
          ]
        }
      }
    },
    origin: 'manual'
  }
];
